import React from 'react'

import FormFactory from '../../../../../components/form/form-factory'
import IFormPage from '../../../../../interfaces/form-page'
import { OptionModelWrapper } from './styles'

const OptionModelForm = ({ dataForm, onSubmit }: IFormPage) => (
  <OptionModelWrapper>
    <FormFactory data={dataForm} onSubmit={onSubmit} />
  </OptionModelWrapper>
)

export default OptionModelForm
